<template>
    <div>
        <div class="layout-sidebar-menu">
            <van-collapse :border="false" v-model="activeNames" accordion>
                <van-cell is-link :border="false" title="首页" @click="skip('/index')">
                    <template #icon>
                        <div class="menu-icon">
                            <a-icon type="home" style="color: #1890ff" />
                        </div>
                    </template>
                </van-cell>
                <van-collapse-item title="课程分类" name="2">
                    <van-cell v-for="item in subjectList"
                              :key="item.subjectId"
                              is-link
                              :border="false"
                              @click="skip({path: '/other/search',query: {subject: item.subjectId}})"
                    >
                        {{item.subjectTitle}}
                    </van-cell>
                    <template #icon>
                        <div class="menu-icon">
                            <a-icon type="appstore" style="color: #faad14" />
                        </div>
                    </template>
                </van-collapse-item>
<!--                <van-cell is-link title="专属课程" :border="false" @click="skip('/other/course-direction',false)">-->
                <van-cell is-link title="教学管理云平台" :border="false" @click="skipToStu">
                    <template #icon>
                        <div class="menu-icon">
                            <a-icon type="carry-out" style="color: #00a879" />
                        </div>
                    </template>
                </van-cell>
            </van-collapse>
            <div v-if="isLogin">
                <div class="divider" />
                <van-cell-group>
                    <van-cell is-link :border="false" title="个人中心" @click="skip('/other/personal/1',true)">
                        <template #icon>
                            <div class="menu-icon">
                                <a-icon type="user" style="color: rgb(24, 31, 255)" />
                            </div>
                        </template>
                    </van-cell>
                    <van-cell is-link :border="false" title="我的课程" @click="skip('/other/personal/2',true)">
                        <template #icon>
                            <div class="menu-icon">
                                <a-icon type="youtube" style="color: #1890ff"/>
                            </div>
                        </template>
                    </van-cell>
                    <van-cell is-link :border="false" title="订单" @click="skip('/other/personal/3',true)">
                        <template #icon>
                            <div class="menu-icon">
                                <a-icon type="unordered-list" style="color: #f5222d" />
                            </div>
                        </template>
                    </van-cell>
                    <van-cell is-link :border="false" title="购物车" @click="skip('/other/shopping-cart',true)">
                        <template #right-icon>
                            <a-badge :count="total" />
                        </template>
                        <template #icon>
                            <div class="menu-icon">
<!--                                <van-icon name="shopping-cart-o" color="#FF8000" />-->
                                <a-icon type="shopping" style="color: #fab314"/>
                            </div>
                        </template>
                    </van-cell>
                </van-cell-group>
                <div class="divider" />
                <div class="sidebar-action">
                    <a-button type="danger" @click="logout" class="logout-btn">退出登录</a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "../../../mixin/common";
    import {createNamespacedHelpers} from "vuex";
    import {logout} from "@api/personal-api";
    import { showSuccessMsg} from "@utils/msg";

    const {mapState} = createNamespacedHelpers('subject');
    const {mapGetters} = createNamespacedHelpers('cart');

    export default {
        name: "LayoutSidebarMenu.vue",
        components: {},

        mixins: [common],
        data() {
            return {
                activeNames: []
            }
        },
        methods: {
            skip(to, needLogin = false) {
                this.changeShowSidebar(false);
                if (!needLogin || this.isLoginClick()) {
                    this.$router.push(to)
                }
            },
            skipToStu() {
              const a = document.createElement("a")
              document.body.appendChild(a)
              a.href = 'https://stu.myhope365.com'
              a.target = '_blank'
              a.click()
              document.body.removeChild(a)
            },
            logout() {
                //退出登录
                logout().then(res => {
                    if (res.code === 0) {
                        showSuccessMsg("退出成功...");
                        setTimeout(() => {
                            location.href = '/';
                        }, 500)
                    }
                });
            }
        },
        computed: {
            ...mapGetters([
                "total",
            ]),
            ...mapState([
                "subjectList"
            ])
        }
    }
</script>

<style scoped lang="less">
    .layout-sidebar-menu {
        /deep/ .van-collapse-item__content {
            padding: 0 0 0 16px;

            .van-cell {
                font-size: 12px;
                line-height: 18px;
                padding: 9px 12px;
            }
        }

        .divider {
            border-bottom: 1px solid #f2f2f2
        }

        .sidebar-action {
            text-align: center;
            padding: 20px;
        }

        .logout-btn {
            color: #f5f5f5;
            background-color: #f5222d;
            border-color: #f5222d;
            height: 30px;
            font-size: 12px;
        }

        .van-cell__right-icon {
            display: none;
        }

        .menu-icon {
            margin-right: 8px;
            justify-content: center;
            display: flex;
            align-items: center;
        }
    }
</style>
